// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__sPqPz","Navcontainer":"Layout_Navcontainer__63EZA","nav-hide":"Layout_nav-hide__0Yu6c","main-content":"Layout_main-content__g2Co-"};